import type { LicenseQuestionAnswerType } from "@/hera-api/client/types.gen";

/** Answer types that use name/address/contact shape (object or NAC fixed list). */
export function isNacStyleAnswerType(
  t: LicenseQuestionAnswerType | string,
): boolean {
  return t === "name_address_contact" || t === "company_contact";
}
